/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./deleteBlock.defs.js";
export { main as default } from "./deleteBlock.defs.js";
